export const printLabInvoice = (bill, settings = {}, logoDataUrl = null) => {
  const win = window.open('', '_blank', 'width=800,height=900');
  if (!win) return;
  const primary = settings.primary_color || '#2563eb';
  const itemsHtml = (bill.items || []).map(item => `<tr><td>${item.item_name || item.name || ''}</td><td style="text-align:right">Rs. ${(item.price || 0).toFixed(2)}</td></tr>`).join('');
  const paymentsHtml = (bill.payments || []).map(p => `<tr><td>${(p.date || '').slice(0, 10)}</td><td style="text-transform:capitalize">${p.mode || ''}</td><td style="text-align:right">Rs. ${(p.amount || 0).toFixed(2)}</td></tr>`).join('');
  const netPayable = (bill.total || 0) - (bill.discount || 0);
  win.document.write(`<html><head><title>Invoice #${bill.reg_no}</title>
    <style>
      body{font-family:Arial,sans-serif;padding:28px;color:#1e293b;font-size:13px}
      .header{display:flex;align-items:flex-start;justify-content:space-between;border-bottom:3px solid ${primary};padding-bottom:14px;margin-bottom:16px}
      .brand{display:flex;align-items:center;gap:12px}
      .brand img{width:60px;height:60px;object-fit:contain}
      .brand h1{margin:0;font-size:20px;color:${primary}}
      .brand p{margin:2px 0;font-size:11px;color:#64748b}
      .invoice-meta{text-align:right}
      .invoice-meta h2{margin:0;font-size:22px;letter-spacing:1px;color:#1e293b}
      .invoice-meta p{margin:2px 0;font-size:12px;color:#64748b}
      .banner{background:#f1f5f9;border-radius:6px;padding:6px 12px;font-size:11px;color:${primary};margin-bottom:14px;text-align:center;font-weight:600}
      .grid2{display:grid;grid-template-columns:1fr 1fr;gap:16px;margin-bottom:16px}
      .box{background:#f8fafc;border-radius:8px;padding:10px 14px}
      .box h4{margin:0 0 4px;font-size:11px;text-transform:uppercase;color:#94a3b8;letter-spacing:0.5px}
      .box p{margin:1px 0;font-size:13px}
      table{width:100%;border-collapse:collapse;margin-top:6px}
      th,td{border:1px solid #e2e8f0;padding:8px;font-size:12.5px}
      th{background:${primary};color:#fff;text-align:left}
      .totals{margin-top:14px;width:280px;margin-left:auto}
      .totals div{display:flex;justify-content:space-between;padding:3px 0;font-size:13px}
      .grand{font-weight:bold;font-size:16px;border-top:2px solid ${primary};margin-top:4px;padding-top:6px;color:${primary}}
      .balance{color:#dc2626;font-weight:bold}
      .paid{color:#059669;font-weight:bold}
      .section-title{font-size:12px;font-weight:600;color:#475569;margin:16px 0 4px}
      .footer{margin-top:28px;border-top:1px solid #e2e8f0;padding-top:10px;text-align:center;font-size:11px;color:#94a3b8}
      .terms{margin-top:16px;font-size:10.5px;color:#94a3b8;white-space:pre-wrap}
      .signature{margin-top:40px;display:flex;justify-content:flex-end}
      .signature div{text-align:center;font-size:11px;color:#64748b;border-top:1px solid #cbd5e1;padding-top:4px;width:160px}
    </style></head>
    <body>
      <div class="header">
        <div class="brand">
          ${logoDataUrl ? `<img src="${logoDataUrl}" />` : ''}
          <div>
            <h1>${settings.lab_name || bill.lab_type || 'Laboratory'}</h1>
            ${settings.lab_address ? `<p>${settings.lab_address}</p>` : ''}
            <p>${[settings.lab_phone, settings.lab_email, settings.lab_website].filter(Boolean).join(' | ')}</p>
          </div>
        </div>
        <div class="invoice-meta">
          <h2>INVOICE</h2>
          <p>Reg No: <strong>#${bill.reg_no}</strong></p>
          <p>Date: ${bill.created_at ? new Date(bill.created_at).toLocaleDateString() : ''}</p>
        </div>
      </div>
      ${settings.header_text ? `<div class="banner">${settings.header_text}</div>` : ''}
      <div class="grid2">
        <div class="box">
          <h4>Patient</h4>
          <p><strong>${bill.patient_name || ''}</strong></p>
          ${bill.patient_mobile ? `<p>${bill.patient_mobile}</p>` : ''}
        </div>
        <div class="box">
          <h4>Details</h4>
          ${bill.referred_by ? `<p>Referred By: ${bill.referred_by}</p>` : ''}
          ${bill.collection_centre ? `<p>Collection Centre: ${bill.collection_centre}</p>` : ''}
          <p>Payment Mode: <span style="text-transform:capitalize">${bill.payment_mode || 'cash'}</span></p>
        </div>
      </div>
      <table><thead><tr><th>Test / Panel</th><th style="text-align:right">Amount</th></tr></thead><tbody>${itemsHtml}</tbody></table>
      <div class="totals">
        <div><span>Subtotal</span><span>Rs. ${(bill.total || 0).toFixed(2)}</span></div>
        ${bill.discount > 0 ? `<div><span>Discount</span><span>- Rs. ${(bill.discount || 0).toFixed(2)}</span></div>` : ''}
        <div class="grand"><span>Net Payable</span><span>Rs. ${netPayable.toFixed(2)}</span></div>
        <div><span>Amount Received</span><span class="paid">Rs. ${(bill.amount_received || 0).toFixed(2)}</span></div>
        <div><span>Balance Due</span><span class="${bill.balance > 0 ? 'balance' : 'paid'}">Rs. ${(bill.balance || 0).toFixed(2)}</span></div>
      </div>
      ${(bill.payments || []).length > 0 ? `
      <div class="section-title">Payment History</div>
      <table><thead><tr><th>Date</th><th>Mode</th><th style="text-align:right">Amount</th></tr></thead><tbody>${paymentsHtml}</tbody></table>
      ` : ''}
      ${bill.remarks ? `<div class="section-title">Remarks</div><p style="font-size:12px">${bill.remarks}</p>` : ''}
      ${settings.terms_text ? `<div class="section-title">Terms & Conditions</div><div class="terms">${settings.terms_text}</div>` : ''}
      <div class="signature"><div>Authorized Signatory</div></div>
      <div class="footer">${settings.footer_text || 'Thank you for choosing us'}</div>
    </body></html>`);
  win.document.close();
  win.focus();
  setTimeout(() => win.print(), 400);
};
